// Generated list of PlatypusBox in-house projects (repo links, descriptions, project artwork in /public/project-art).
export const inhouseProjects = [
  {
    "id": "2DTopDownIsometricShooterStudy",
    "title": "2D Top Down Isometric Shooter Study",
    "category": "Games",
    "tagline": "Study project for a 2D top-down isometric shooter",
    "description": "A Unity learning project for a top-down shooter with a sound system and camera effects.",
    "tags": [
      "Unity, C#"
    ],
    "repo": "https://github.com/PlatypusBoxOrganization/2DTopDownIsometricShooterStudy",
    "private": true,
    "image": "/project-art/2DTopDownIsometricShooterStudy.webp"
  },
  {
    "id": "2D_Cookie_Game",
    "title": "2D Cookie Game",
    "category": "Games",
    "tagline": "Cookie collecting and depositing game",
    "description": "A 2D Unity game where cookies spawn and are dropped into a deposit box for score.",
    "tags": [
      "Unity, C#"
    ],
    "repo": "https://github.com/PlatypusBoxOrganization/2D_Cookie_Game",
    "private": true,
    "image": "/project-art/2D_Cookie_Game.webp"
  },
  {
    "id": "3D-Mario-Kart",
    "title": "3D Mario Kart",
    "category": "Games",
    "tagline": "3D Mario Kart style racing world with skyboxes",
    "description": "A Unity kart-racing environment with many skybox scenes, Beautify post effect and animated characters.",
    "tags": [
      "Unity, C#, Beautify"
    ],
    "repo": "https://github.com/PlatypusBoxOrganization/3D-Mario-Kart",
    "private": true,
    "image": "/project-art/3D-Mario-Kart.webp"
  },
  {
    "id": "ARBatteryShowcase",
    "title": "AR Battery Showcase",
    "category": "AR / VR",
    "tagline": "AR showcase of a home battery product",
    "description": "A Unity AR Foundation project to place and explore a battery product in the real room, on the XR Interaction Toolkit AR template.",
    "tags": [
      "Unity, C#, AR Foundation, XRI"
    ],
    "repo": "https://github.com/PlatypusBoxOrganization/ARBatteryShowcase",
    "private": true,
    "image": "/project-art/ARBatteryShowcase.webp"
  },
  {
    "id": "ARCarBattle",
    "title": "AR Car Battle",
    "category": "AR / VR",
    "tagline": "AR car battle prototype",
    "description": "A Unity AR project on the AR Foundation template, intended for car battles in the real world.",
    "tags": [
      "Unity, C#, AR Foundation"
    ],
    "repo": "https://github.com/PlatypusBoxOrganization/ARCarBattle",
    "private": true,
    "image": "/project-art/ARCarBattle.webp"
  },
  {
    "id": "ARCarOcclusion",
    "title": "AR Car Occlusion",
    "category": "AR / VR",
    "tagline": "AR car with real-world occlusion",
    "description": "An AR Foundation experiment for occluding a virtual car behind real objects.",
    "tags": [
      "Unity, C#, AR Foundation"
    ],
    "repo": "https://github.com/PlatypusBoxOrganization/ARCarOcclusion",
    "private": true,
    "image": "/project-art/ARCarOcclusion.webp"
  },
  {
    "id": "ARCarRotation",
    "title": "AR Car Rotation",
    "category": "AR / VR",
    "tagline": "AR car with rotate gestures",
    "description": "An AR Foundation experiment for rotating a virtual car with touch gestures.",
    "tags": [
      "Unity, C#, AR Foundation"
    ],
    "repo": "https://github.com/PlatypusBoxOrganization/ARCarRotation",
    "private": true,
    "image": "/project-art/ARCarRotation.webp"
  },
  {
    "id": "AR_Tourist",
    "title": "AR Tourist",
    "category": "AR / VR",
    "tagline": "AR museum tourist guide",
    "description": "A Unity prototype of a tourist walking through a museum scene with a player and camera controller.",
    "tags": [
      "Unity, C#"
    ],
    "repo": "https://github.com/PlatypusBoxOrganization/AR_Tourist",
    "private": true,
    "image": "/project-art/AR_Tourist.webp"
  },
  {
    "id": "AR_WallBuilder_Int",
    "title": "AR Wall Builder",
    "category": "AR / VR",
    "tagline": "Build virtual walls in AR",
    "description": "A Unity AR Foundation / XR Interaction Toolkit project to place and customise virtual walls in a real room.",
    "tags": [
      "Unity, C#, AR Foundation, XR Interaction Toolkit"
    ],
    "repo": "https://github.com/PlatypusBoxOrganization/AR_WallBuilder_Int",
    "private": true,
    "image": "/project-art/AR_WallBuilder_Int.webp"
  },
  {
    "id": "AmazingTrack",
    "title": "Amazing Track",
    "category": "Games",
    "tagline": "Amazing Track ball runner built with ECS",
    "description": "A Unity ball-and-track game built on an ECS architecture with dependency injection.",
    "tags": [
      "Unity, C#, ECS, Zenject-style DI"
    ],
    "repo": "https://github.com/PlatypusBoxOrganization/AmazingTrack",
    "private": true,
    "image": "/project-art/AmazingTrack.webp"
  },
  {
    "id": "Archiection",
    "title": "Archiection",
    "category": "AR / VR",
    "tagline": "AR measuring and object placement for architecture",
    "description": "A Unity AR Foundation project (branch AR-Foundation) for placing and scaling objects in the real world and measuring space.",
    "tags": [
      "Unity, C#, AR Foundation (ARCore/ARKit)"
    ],
    "repo": "https://github.com/PlatypusBoxOrganization/Archiection",
    "private": true,
    "image": "/project-art/Archiection.webp"
  },
  {
    "id": "Architection_FirstMil",
    "title": "Architection First Mil",
    "category": "AR / VR",
    "tagline": "First milestone of the architecture AR app",
    "description": "The earlier build of Archiection: AR ruler and object placement with anchors.",
    "tags": [
      "Unity, C#, AR Foundation"
    ],
    "repo": "https://github.com/PlatypusBoxOrganization/Architection_FirstMil",
    "private": true,
    "image": "/project-art/Architection_FirstMil.webp"
  },
  {
    "id": "AttendanceRecordApp",
    "title": "Attendance Record App",
    "category": "Business Apps",
    "tagline": "Employee attendance app with admin and employee views",
    "description": "A Unity attendance tracker with date picker, timer and separate admin and employee scenes.",
    "tags": [
      "Unity, C#"
    ],
    "repo": "https://github.com/PlatypusBox/AttendanceRecordApp",
    "private": true,
    "image": "/project-art/AttendanceRecordApp.webp"
  },
  {
    "id": "AutomatedVideoGenerator",
    "title": "Automated Video Generator",
    "category": "Simulation & Tools",
    "tagline": "Generate paint-by-numbers style videos from JSON image data",
    "description": "A Unity tool that reads JSON region data and animates a brush painting an image region by region, to render automated videos.",
    "tags": [
      "Unity, C#, JSON input"
    ],
    "repo": "https://github.com/PlatypusBoxOrganization/AutomatedVideoGenerator",
    "private": true,
    "image": "/project-art/AutomatedVideoGenerator.webp"
  },
  {
    "id": "AwesomeRunner",
    "title": "Awesome Runner",
    "category": "Games",
    "tagline": "3D endless runner with lasers and coins",
    "description": "A Unity touch-controlled endless runner with object pooling, coins and obstacles.",
    "tags": [
      "Unity, C#, TextMesh Pro"
    ],
    "repo": "https://github.com/PlatypusBoxOrganization/AwesomeRunner",
    "private": true,
    "image": "/project-art/AwesomeRunner.webp"
  },
  {
    "id": "BLELatest_UnityPlugin",
    "title": "BLE Latest Unity Plugin",
    "category": "IoT & Hardware",
    "tagline": "Bluetooth LE plugin for Unity with a betting-style demo",
    "description": "A Unity plugin with an Android Java side for Bluetooth Low Energy device communication, with example scenes for Android and VR.",
    "tags": [
      "Unity, C#, Java (Android BLE)"
    ],
    "repo": "https://github.com/PlatypusBoxOrganization/BLELatest_UnityPlugin",
    "private": true,
    "image": "/project-art/BLELatest_UnityPlugin.webp"
  },
  {
    "id": "BLE_ESP32",
    "title": "BLE ESP32",
    "category": "IoT & Hardware",
    "tagline": "Bluetooth LE with ESP32 on Meta SDK base",
    "description": "A Unity project for connecting to an ESP32 board over BLE, built on the Meta Interaction SDK sample base.",
    "tags": [
      "Unity, C#, BLE, ESP32"
    ],
    "repo": "https://github.com/PlatypusBoxOrganization/BLE_ESP32",
    "private": true,
    "image": "/project-art/BLE_ESP32.webp"
  },
  {
    "id": "BLE_ESP_IOS",
    "title": "BLE ESP IOS",
    "category": "IoT & Hardware",
    "tagline": "iOS BLE controller for ESP robot and weather station",
    "description": "A Unity iOS app that connects to ESP devices over BLE, with weather station and robot server demos.",
    "tags": [
      "Unity, C#, iOS BLE plugin"
    ],
    "repo": "https://github.com/YuvrajPhoinex/BLE_ESP_IOS",
    "private": true,
    "image": "/project-art/BLE_ESP_IOS.webp"
  },
  {
    "id": "BNumbers-main",
    "title": "BNumbers",
    "category": "Games",
    "tagline": "Number block puzzle with LeanTween animations",
    "description": "A Unity number block puzzle game with block falling, moving and tween animations.",
    "tags": [
      "Unity, C#, LeanTween"
    ],
    "repo": "https://github.com/PlatypusBoxOrganization/BNumbers-main",
    "private": true,
    "image": "/project-art/BNumbers-main.webp"
  },
  {
    "id": "BallTrajectoryUnity",
    "title": "Ball Trajectory Unity",
    "category": "Games",
    "tagline": "Billiards game with trajectory aiming and PlayFab",
    "description": "A Unity billiards game with lightning visual effects, PlayFab accounts and Google ads.",
    "tags": [
      "Unity, C#, PlayFab, Google Mobile Ads"
    ],
    "repo": "https://github.com/PlatypusBoxOrganization/BallTrajectoryUnity",
    "private": true,
    "image": "/project-art/BallTrajectoryUnity.webp"
  },
  {
    "id": "Blackjack_unity",
    "title": "Blackjack unity",
    "category": "Games",
    "tagline": "Blackjack card game against a dealer",
    "description": "A Unity blackjack game with a human player, computer player, dealer, deck and hand logic.",
    "tags": [
      "Unity, C#"
    ],
    "repo": "https://github.com/PlatypusBoxOrganization/Blackjack_unity",
    "private": true,
    "image": "/project-art/Blackjack_unity.webp"
  },
  {
    "id": "BoxJump",
    "title": "Box Jump",
    "category": "Games",
    "tagline": "One-tap box jumping game with ads",
    "description": "A simple Unity mobile game with banner, interstitial and rewarded ads.",
    "tags": [
      "Unity, C#, Unity Ads, LeanTween"
    ],
    "repo": "https://github.com/PlatypusBoxOrganization/BoxJump",
    "private": true,
    "image": "/project-art/BoxJump.webp"
  },
  {
    "id": "Bus-Subway-New",
    "title": "Bus Subway New",
    "category": "Games",
    "tagline": "Endless-runner style bus game with ads and localisation",
    "description": "A Unity mobile endless-runner (branch kanishkModified) with pooled road terrain, bonuses and Google Mobile Ads.",
    "tags": [
      "Unity, C#, Google Mobile Ads"
    ],
    "repo": "https://github.com/PlatypusBoxOrganization/Bus-Subway-New",
    "private": true,
    "image": "/project-art/Bus-Subway-New.webp"
  },
  {
    "id": "Chicago_SimCity",
    "title": "Chicago Sim City",
    "category": "Simulation & Tools",
    "tagline": "Generate a 3D city and road network from OpenStreetMap data",
    "description": "A Unity project based on an OSM road-network sample, extended with building LODs, material painting and a city exporter, with a Chicago focus.",
    "tags": [
      "Unity, C#, OpenStreetMap data"
    ],
    "repo": "https://github.com/PlatypusBoxOrganization/Chicago_SimCity",
    "private": true,
    "image": "/project-art/Chicago_SimCity.webp"
  },
  {
    "id": "CircuitSimulator",
    "title": "Circuit Simulator",
    "category": "Simulation & Tools",
    "tagline": "Breadboard circuit simulator",
    "description": "A Unity circuit simulation with a breadboard, batteries and metal strips, using matrix maths for node voltages.",
    "tags": [
      "Unity, C#"
    ],
    "repo": "https://github.com/PlatypusBoxOrganization/CircuitSimulator",
    "private": true,
    "image": "/project-art/CircuitSimulator.webp"
  },
  {
    "id": "Cricket_Unity",
    "title": "Cricket Unity",
    "category": "Games",
    "tagline": "3D cricket game with bowling and batting",
    "description": "A Unity cricket game with a bowler camera and power slider, batsmen, fielders and crowd audio.",
    "tags": [
      "Unity, C#"
    ],
    "repo": "https://github.com/PlatypusBoxOrganization/Cricket_Unity",
    "private": true,
    "image": "/project-art/Cricket_Unity.webp"
  },
  {
    "id": "CulinaryApp",
    "title": "Culinary App",
    "category": "Mobile & Web Apps",
    "tagline": "Recipe app with image picker",
    "description": "A Unity mobile recipe app prototype where users enter a recipe name and pick a picture.",
    "tags": [
      "Unity, C#"
    ],
    "repo": "https://github.com/PlatypusBoxOrganization/CulinaryApp",
    "private": true,
    "image": "/project-art/CulinaryApp.webp"
  },
  {
    "id": "Darkest-Dungeon-Unity",
    "title": "Darkest Dungeon Unity",
    "category": "Games",
    "tagline": "Darkest Dungeon style game prototype with Photon demos",
    "description": "A Unity project that bundles Photon PUN demos, FMOD audio migration utilities and image-effect editors as groundwork for a dungeon crawler.",
    "tags": [
      "Unity, C#, Photon PUN, FMOD"
    ],
    "repo": "https://github.com/PlatypusBoxOrganization/Darkest-Dungeon-Unity",
    "private": true,
    "image": "/project-art/Darkest-Dungeon-Unity.webp"
  },
  {
    "id": "Design_WearAR",
    "title": "Design Wear AR",
    "category": "AR / VR",
    "tagline": "AR clothing design with capture and recording",
    "description": "A Unity AR project (branch develop-platypus) for designing wearables, with screen, camera and audio capture tools.",
    "tags": [
      "Unity, C#, capture plugin"
    ],
    "repo": "https://github.com/PlatypusBoxOrganization/Design_WearAR",
    "private": true,
    "image": "/project-art/Design_WearAR.webp"
  },
  {
    "id": "Electronics_Ecom",
    "title": "Electronics Ecom",
    "category": "Mobile & Web Apps",
    "tagline": "Electronics e-commerce app in Unity with Facebook and Google login",
    "description": "A Unity mobile store app (branch Ashitosh) with Facebook SDK samples, Google Sign-In and payment hooks.",
    "tags": [
      "Unity, C#, Facebook SDK, Google Sign-In"
    ],
    "repo": "https://github.com/PlatypusBoxOrganization/Electronics_Ecom",
    "private": true,
    "image": "/project-art/Electronics_Ecom.webp"
  },
  {
    "id": "Elite-Ludo-Game-V6",
    "title": "Elite Ludo Game V6",
    "category": "Games",
    "tagline": "Online multiplayer Ludo with chat, shop and bots",
    "description": "A full Unity Ludo game with login, in-game store, emoji/chat bubbles, friends, bots and WebView communication.",
    "tags": [
      "Unity, C#, WebView plugin",
      "Game backend (not included)"
    ],
    "repo": "https://github.com/PlatypusBoxOrganization/Elite-Ludo-Game-V6",
    "private": true,
    "image": "/project-art/Elite-Ludo-Game-V6.webp"
  },
  {
    "id": "FIghterGame",
    "title": "Fighter Game",
    "category": "Games",
    "tagline": "2D/3D fighting game framework",
    "description": "A Unity fighting game with data-driven moves, hit/throw data and a stage.",
    "tags": [
      "Unity, C#"
    ],
    "repo": "https://github.com/PlatypusBoxOrganization/FIghterGame",
    "private": true,
    "image": "/project-art/FIghterGame.webp"
  },
  {
    "id": "FoodDeliveryUnity",
    "title": "Food Delivery Unity",
    "category": "Mobile & Web Apps",
    "tagline": "Food delivery app UI prototype",
    "description": "A Unity prototype of a food delivery user home screen.",
    "tags": [
      "Unity, C#, TextMesh Pro"
    ],
    "repo": "https://github.com/PlatypusBoxOrganization/FoodDeliveryUnity",
    "private": true,
    "image": "/project-art/FoodDeliveryUnity.webp"
  },
  {
    "id": "FootballGame",
    "title": "Football Game",
    "category": "Games",
    "tagline": "Football game like Score Hero",
    "description": "A Unity football game (branch developV2) inspired by Score Hero, with extended skyboxes and saved settings.",
    "tags": [
      "Unity, C#"
    ],
    "repo": "https://github.com/PlatypusBox/FootballGame",
    "private": true,
    "image": "/project-art/FootballGame.webp"
  },
  {
    "id": "GOLF",
    "title": "GOLF",
    "category": "AR / VR",
    "tagline": "VR golf exhibition experience",
    "description": "A Unity VR golf project, tagged exhibition ready, built on Meta Interaction SDK examples (hand grab, pose and gesture).",
    "tags": [
      "Unity, C#, Meta XR / Interaction SDK, Oculus spatializer"
    ],
    "repo": "https://github.com/PlatypusBoxOrganization/GOLF",
    "private": true,
    "image": "/project-art/GOLF.webp"
  },
  {
    "id": "GolfProject",
    "title": "Golf Project",
    "category": "Games",
    "tagline": "Mini golf prototype with draggable hole",
    "description": "A small Unity golf prototype in which a hole can be dragged and sized.",
    "tags": [
      "Unity, C#"
    ],
    "repo": "https://github.com/PlatypusBoxOrganization/GolfProject",
    "private": true,
    "image": "/project-art/GolfProject.webp"
  },
  {
    "id": "HappyWheels",
    "title": "Happy Wheels",
    "category": "Games",
    "tagline": "Happy Wheels style physics vehicle game",
    "description": "A Unity prototype of a physics vehicle obstacle game with fuel, spawners and goals.",
    "tags": [
      "Unity, C#"
    ],
    "repo": "https://github.com/PlatypusBoxOrganization/HappyWheels",
    "private": true,
    "image": "/project-art/HappyWheels.webp"
  },
  {
    "id": "HoinKyomaSnake",
    "title": "Hoin Kyoma Snake",
    "category": "Games",
    "tagline": "Retro Snake game",
    "description": "A Unity snake game with obstacles, pickups, score and menus.",
    "tags": [
      "Unity, C#"
    ],
    "repo": "https://github.com/PlatypusBox/HoinKyomaSnake",
    "private": true,
    "image": "/project-art/HoinKyomaSnake.webp"
  },
  {
    "id": "ICSI_Sim",
    "title": "ICSI Sim",
    "category": "Simulation & Tools",
    "tagline": "Soft-body simulation for an ICSI medical procedure",
    "description": "A Unity simulation using Obi Softbody to model ICSI (intracytoplasmic sperm injection) style deformation.",
    "tags": [
      "Unity, C#, Obi Softbody"
    ],
    "repo": "https://github.com/PlatypusBoxOrganization/ICSI_Sim",
    "private": true,
    "image": "/project-art/ICSI_Sim.webp"
  },
  {
    "id": "IFE_Project",
    "title": "IFE Project",
    "category": "Business Apps",
    "tagline": "In-flight entertainment with a real-world map",
    "description": "A Unity in-flight entertainment system with a real-world map (Online Maps plugin), flights between airports and entertainment panels.",
    "tags": [
      "Unity, C#, Online Maps plugin"
    ],
    "repo": "https://github.com/PlatypusBoxOrganization/IFE_Project",
    "private": true,
    "image": "/project-art/IFE_Project.webp"
  },
  {
    "id": "JaggobaaiApp",
    "title": "Jaggobaai App",
    "category": "Mobile & Web Apps",
    "tagline": "Mobile shell app that wraps the Jaggobaai web experience",
    "description": "A Unity mobile app (the README still says Waves_Application) that hosts a web view so the web product runs as an Android/iOS app.",
    "tags": [
      "Unity, C#, UniWebView plugin"
    ],
    "repo": "https://github.com/PlatypusBoxOrganization/JaggobaaiApp",
    "private": true,
    "image": "/project-art/JaggobaaiApp.webp"
  },
  {
    "id": "LightTrailRoom_Project",
    "title": "Light Trail Room Project",
    "category": "Simulation & Tools",
    "tagline": "Calm underwater light-trail scene with swimming fish",
    "description": "A tiny Unity visual scene with animated fish and light trails.",
    "tags": [
      "Unity, C#"
    ],
    "repo": "https://github.com/PlatypusBoxOrganization/LightTrailRoom_Project",
    "private": true,
    "image": "/project-art/LightTrailRoom_Project.webp"
  },
  {
    "id": "LoyaltyCustomerApp",
    "title": "Loyalty Customer App",
    "category": "Business Apps",
    "tagline": "Customer loyalty app with QR generator and scanner",
    "description": "A Unity mobile app with login, profile editing, QR code generation and QR scanning for loyalty rewards.",
    "tags": [
      "Unity, C#, QR libraries"
    ],
    "repo": "https://github.com/PlatypusBox/LoyaltyCustomerApp",
    "private": true,
    "image": "/project-art/LoyaltyCustomerApp.webp"
  },
  {
    "id": "Madrix5Controller",
    "title": "Madrix5Controller",
    "category": "IoT & Hardware",
    "tagline": "Control MADRIX 5 LED lighting from Unity over ArtNet and HTTP",
    "description": "A Unity controller app that drives MADRIX 5 LED lighting and sequenced multi-screen videos using ArtNet and the MADRIX HTTP remote API.",
    "tags": [
      "Unity, C#, ArtNet, HTTP"
    ],
    "repo": "https://github.com/PlatypusBoxOrganization/Madrix5Controller",
    "private": true,
    "image": "/project-art/Madrix5Controller.webp"
  },
  {
    "id": "Match3",
    "title": "Match3",
    "category": "Games",
    "tagline": "Match-3 puzzle with levels, obstacles and timers",
    "description": "A Unity match-3 game with a grid, special clearing pieces and different level goals.",
    "tags": [
      "Unity, C#"
    ],
    "repo": "https://github.com/PlatypusBoxOrganization/Match3",
    "private": true,
    "image": "/project-art/Match3.webp"
  },
  {
    "id": "MazeGameUnity",
    "title": "Maze Game Unity",
    "category": "Games",
    "tagline": "Touch joystick maze game",
    "description": "A Unity maze game with a virtual joystick and a finish tile.",
    "tags": [
      "Unity, C#, Joystick Pack"
    ],
    "repo": "https://github.com/PlatypusBoxOrganization/MazeGameUnity",
    "private": true,
    "image": "/project-art/MazeGameUnity.webp"
  },
  {
    "id": "Mediapipe_FaceFilter",
    "title": "Mediapipe Face Filter",
    "category": "AI & Vision",
    "tagline": "Real-time face and hand tracking filters using MediaPipe",
    "description": "A Unity project using the MediaPipe Unity plugin to detect faces, landmarks, hands and segmentation from a webcam for AR filters.",
    "tags": [
      "Unity, C#, MediaPipe Unity plugin"
    ],
    "repo": "https://github.com/PlatypusBoxOrganization/Mediapipe_FaceFilter",
    "private": true,
    "image": "/project-art/Mediapipe_FaceFilter.webp"
  },
  {
    "id": "MoCapOpenCV",
    "title": "Mo Cap Open CV",
    "category": "AI & Vision",
    "tagline": "Motion capture, face and document scanning with OpenCV (Android)",
    "description": "A Unity Android project using OpenCV for Unity and dlib to detect faces, recognise them and scan documents.",
    "tags": [
      "Unity, C#, OpenCV for Unity, dlib"
    ],
    "repo": "https://github.com/PlatypusBox/MoCapOpenCV",
    "private": true,
    "image": "/project-art/MoCapOpenCV.webp"
  },
  {
    "id": "MobileCricketMultiplayer",
    "title": "Mobile Cricket Multiplayer",
    "category": "AI & Vision",
    "tagline": "Mobile cricket multiplayer prototype",
    "description": "An early Unity mobile cricket prototype with batting and bowling and a stadium scene.",
    "tags": [
      "Unity, C#"
    ],
    "repo": "https://github.com/PlatypusBoxOrganization/MobileCricketMultiplayer",
    "private": true,
    "image": "/project-art/MobileCricketMultiplayer.webp"
  },
  {
    "id": "MoveMe",
    "title": "Move Me",
    "category": "Games",
    "tagline": "Swipe tile puzzle game",
    "description": "A Unity swipe puzzle with a grid of coloured units, panels and ads.",
    "tags": [
      "Unity, C#"
    ],
    "repo": "https://github.com/machine0man/MoveMe",
    "private": false,
    "image": "/project-art/MoveMe.webp"
  },
  {
    "id": "Multiplayer-FPS",
    "title": "Multiplayer FPS",
    "category": "Games",
    "tagline": "Multiplayer first-person shooter on Photon",
    "description": "A Unity multiplayer FPS prototype with Photon chat and networking.",
    "tags": [
      "Unity, C#, Photon"
    ],
    "repo": "https://github.com/PlatypusBoxOrganization/Multiplayer-FPS",
    "private": true,
    "image": "/project-art/Multiplayer-FPS.webp"
  },
  {
    "id": "MultiplayerQuizGame",
    "title": "Multiplayer Quiz Game",
    "category": "Games",
    "tagline": "Multiplayer quiz game on Photon",
    "description": "A Unity multiplayer quiz prototype using Photon chat and lobby with JSON question data.",
    "tags": [
      "Unity, C#, Photon, JSON"
    ],
    "repo": "https://github.com/PlatypusBoxOrganization/MultiplayerQuizGame",
    "private": true,
    "image": "/project-art/MultiplayerQuizGame.webp"
  },
  {
    "id": "MyMotherDontWaterPlants",
    "title": "My Mother Dont Water Plants",
    "category": "Games",
    "tagline": "Plant watering reminder game with ads and server sync",
    "description": "A Unity mobile game about remembering to water plants, with ads, config download and encrypted data.",
    "tags": [
      "Unity, C#, Google Mobile Ads"
    ],
    "repo": "https://github.com/PlatypusBox/MyMotherDontWaterPlants",
    "private": true,
    "image": "/project-art/MyMotherDontWaterPlants.webp"
  },
  {
    "id": "NodulusDemo",
    "title": "Nodulus Demo",
    "category": "Games",
    "tagline": "Nodulus puzzle game demo (Aditya version)",
    "description": "A Unity demo (branch AdityajeetVersion) of the Nodulus game with logo, main menu and game scenes.",
    "tags": [
      "Unity, C#, Post-Processing Stack"
    ],
    "repo": "https://github.com/PlatypusBoxOrganization/NodulusDemo",
    "private": true,
    "image": "/project-art/NodulusDemo.webp"
  },
  {
    "id": "NumberManager_Main",
    "title": "Number Manager Main",
    "category": "Business Apps",
    "tagline": "Number/bet voucher manager with spreadsheet-style entry",
    "description": "A Unity desktop app using a spreadsheet-style grid, voucher and Firestore pattern for managing numeric bet entries and accounts.",
    "tags": [
      "Unity, C#, Firebase Firestore"
    ],
    "repo": "https://github.com/PlatypusBoxOrganization/NumberManager_Main",
    "private": true,
    "image": "/project-art/NumberManager_Main.webp"
  },
  {
    "id": "NumberTetris_Unity",
    "title": "Number Tetris Unity",
    "category": "Games",
    "tagline": "Tetris with numbers",
    "description": "A Unity puzzle game where number blocks fall like Tetris.",
    "tags": [
      "Unity, C#"
    ],
    "repo": "https://github.com/PlatypusBoxOrganization/NumberTetris_Unity",
    "private": true,
    "image": "/project-art/NumberTetris_Unity.webp"
  },
  {
    "id": "NumeroSoftProject",
    "title": "Numero Soft Project",
    "category": "Business Apps",
    "tagline": "Numerology client manager with Loshu grid and Chaldean numbers",
    "description": "A Unity desktop app for numerologists: manage clients, calculate Kua, Mulank and Chaldean numbers and draw the Loshu grid.",
    "tags": [
      "Unity, C#"
    ],
    "repo": "https://github.com/PlatypusBoxOrganization/NumeroSoftProject",
    "private": true,
    "image": "/project-art/NumeroSoftProject.webp"
  },
  {
    "id": "ObjectRecognitionApp",
    "title": "Object Recognition App",
    "category": "AI & Vision",
    "tagline": "Object, face and hand recognition with MediaPipe",
    "description": "A Unity app with MediaPipe solutions: face detection, face mesh, hair segmentation, hand tracking, holistic and iris.",
    "tags": [
      "Unity, C#, MediaPipe Unity plugin"
    ],
    "repo": "https://github.com/purirohit531/ObjectRecognitionApp",
    "private": true,
    "image": "/project-art/ObjectRecognitionApp.webp"
  },
  {
    "id": "PianoVR-main",
    "title": "Piano VR",
    "category": "AR / VR",
    "tagline": "Play and learn piano in VR with MIDI songs",
    "description": "A Unity VR/mixed-reality piano with hand tracking, where MIDI files drive the keys.",
    "tags": [
      "Unity, C#, Meta XR interaction SDK, MIDI libraries"
    ],
    "repo": "https://github.com/PlatypusBoxOrganization/PianoVR-main",
    "private": true,
    "image": "/project-art/PianoVR-main.webp"
  },
  {
    "id": "PingPongUnity",
    "title": "Ping Pong Unity",
    "category": "Games",
    "tagline": "3D ping pong with bot and two-player mode",
    "description": "A Unity ping pong game with single player vs bot and local two player in a stadium.",
    "tags": [
      "Unity, C#"
    ],
    "repo": "https://github.com/PlatypusBoxOrganization/PingPongUnity",
    "private": true,
    "image": "/project-art/PingPongUnity.webp"
  },
  {
    "id": "PlatypusMailer",
    "title": "Platypus Mailer",
    "category": "Business Apps",
    "tagline": "Desktop bulk email sender",
    "description": "A Unity desktop tool for composing and sending emails to a loaded list of recipients.",
    "tags": [
      "Unity, C#, SMTP/email API"
    ],
    "repo": "https://github.com/PlatypusBoxOrganization/PlatypusMailer",
    "private": true,
    "image": "/project-art/PlatypusMailer.webp"
  },
  {
    "id": "PolyRace",
    "title": "Poly Race",
    "category": "Games",
    "tagline": "Low-poly racing game with explosion effects",
    "description": "A Unity low-poly race game using DOTween animation and procedural track pieces.",
    "tags": [
      "Unity, C#, DOTween"
    ],
    "repo": "https://github.com/PlatypusBoxOrganization/PolyRace",
    "private": true,
    "image": "/project-art/PolyRace.webp"
  },
  {
    "id": "PracticePicButtons",
    "title": "Practice Pic Buttons",
    "category": "Simulation & Tools",
    "tagline": "UI button practice project",
    "description": "A tiny Unity practice project with picture buttons.",
    "tags": [
      "Unity, C#"
    ],
    "repo": "https://github.com/PlatypusBox/PracticePicButtons",
    "private": true,
    "image": "/project-art/PracticePicButtons.webp"
  },
  {
    "id": "PuzzleMobile",
    "title": "Puzzle Mobile",
    "category": "Games",
    "tagline": "Collection of mobile puzzle mini-games",
    "description": "A Unity set of small puzzles: draw a path, matching objects, weigh objects and a slingshot bird.",
    "tags": [
      "Unity, C#"
    ],
    "repo": "https://github.com/PlatypusBoxOrganization/PuzzleMobile",
    "private": true,
    "image": "/project-art/PuzzleMobile.webp"
  },
  {
    "id": "QRSelfieApplication",
    "title": "QR Selfie Application",
    "category": "Mobile & Web Apps",
    "tagline": "Selfie kiosk with QR code and Google Drive upload",
    "description": "A Unity app that captures a selfie, uploads it to Google Drive and presents a QR code for download.",
    "tags": [
      "Unity, C#, Google Drive API"
    ],
    "repo": "https://github.com/PlatypusBoxOrganization/QRSelfieApplication",
    "private": true,
    "image": "/project-art/QRSelfieApplication.webp"
  },
  {
    "id": "RacingDemoVR",
    "title": "Racing Demo VR",
    "category": "AR / VR",
    "tagline": "VR racing demo on Meta Interaction SDK",
    "description": "A Unity VR racing demo built on the Meta Interaction SDK examples with a spatial audio manager.",
    "tags": [
      "Unity, C#, Meta XR SDK"
    ],
    "repo": "https://github.com/PlatypusBoxOrganization/RacingDemoVR",
    "private": true,
    "image": "/project-art/RacingDemoVR.webp"
  },
  {
    "id": "RandomPixels",
    "title": "Random Pixels",
    "category": "Simulation & Tools",
    "tagline": "Plot random pixels on a texture",
    "description": "A tiny Unity experiment that plots pixels onto a texture.",
    "tags": [
      "Unity, C#"
    ],
    "repo": "https://github.com/PlatypusBox/RandomPixels",
    "private": true,
    "image": "/project-art/RandomPixels.webp"
  },
  {
    "id": "RedRunner",
    "title": "Red Runner",
    "category": "Games",
    "tagline": "Red Runner platformer with a save-game system",
    "description": "Unity project based on the Red Runner platformer, with a flexible save game system (auto, custom, web).",
    "tags": [
      "Unity, C#, Easy Save style plugin"
    ],
    "repo": "https://github.com/PlatypusBoxOrganization/RedRunner",
    "private": true,
    "image": "/project-art/RedRunner.webp"
  },
  {
    "id": "Roulette",
    "title": "Roulette",
    "category": "Games",
    "tagline": "Roulette game with 1, 2 and 4 player modes",
    "description": "A Unity roulette game (branch BharatMobility) with betting chips, ads and several player modes.",
    "tags": [
      "Unity, C#, LeanTween, ads SDK"
    ],
    "repo": "https://github.com/PlatypusBoxOrganization/Roulette",
    "private": true,
    "image": "/project-art/Roulette.webp"
  },
  {
    "id": "RouletteGame",
    "title": "Roulette Game",
    "category": "IoT & Hardware",
    "tagline": "Roulette with Richtap haptic feedback",
    "description": "A Unity roulette game with a loading scene and Richtap haptic effect support.",
    "tags": [
      "Unity, C#, Richtap SDK"
    ],
    "repo": "https://github.com/PlatypusBoxOrganization/RouletteGame",
    "private": true,
    "image": "/project-art/RouletteGame.webp"
  },
  {
    "id": "Rummy_Unity",
    "title": "Rummy Unity",
    "category": "Games",
    "tagline": "Rummy card game prototype",
    "description": "A Unity prototype of a rummy card game with card views and panels.",
    "tags": [
      "Unity, C#"
    ],
    "repo": "https://github.com/PlatypusBoxOrganization/Rummy_Unity",
    "private": true,
    "image": "/project-art/Rummy_Unity.webp"
  },
  {
    "id": "STPD_U",
    "title": "STPD Unity",
    "category": "IoT & Hardware",
    "tagline": "Bluetooth serial terminal and joystick controller",
    "description": "A Unity Android app for Bluetooth classic communication: device discovery, terminal, joystick and Android-to-Android connection. A fork also exists under Aytasat.",
    "tags": [
      "Unity, C#, Android Bluetooth plugin"
    ],
    "repo": "https://github.com/PlatypusBox/STPD_U",
    "private": true,
    "image": "/project-art/STPD_U.webp"
  },
  {
    "id": "ScanBox_project",
    "title": "Scan Box project",
    "category": "AR / VR",
    "tagline": "ARDK based scanning and AR networking project",
    "description": "A Unity project on the Niantic ARDK with depth, hand tracking, anchors and shared AR networking samples.",
    "tags": [
      "Unity, C#, Niantic ARDK"
    ],
    "repo": "https://github.com/PlatypusBoxOrganization/ScanBox_project",
    "private": true,
    "image": "/project-art/ScanBox_project.webp"
  },
  {
    "id": "ScaniverseProject",
    "title": "Scaniverse Project",
    "category": "Simulation & Tools",
    "tagline": "Scanned 3D model viewer with touch navigation and drawing",
    "description": "A Unity project (branch r-scaniverse) for viewing scanned 3D captures with free camera, touch gestures and annotation drawing.",
    "tags": [
      "Unity, C#, Lean Touch"
    ],
    "repo": "https://github.com/PlatypusBox/ScaniverseProject",
    "private": true,
    "image": "/project-art/ScaniverseProject.webp"
  },
  {
    "id": "SelfieSuzukiApp_int",
    "title": "Selfie Suzuki App",
    "category": "Mobile & Web Apps",
    "tagline": "Selfie capture app for a Suzuki campaign",
    "description": "A single-scene Unity mobile app for taking a branded selfie.",
    "tags": [
      "Unity, C#"
    ],
    "repo": "https://github.com/PlatypusBoxOrganization/SelfieSuzukiApp_int",
    "private": true,
    "image": "/project-art/SelfieSuzukiApp_int.webp"
  },
  {
    "id": "SimpleAcc_Soft",
    "title": "Simple Acc Soft",
    "category": "Business Apps",
    "tagline": "Desktop accounting and party-ledger software built in Unity, backed by Firebase",
    "description": "A Unity 6 desktop application for party-wise accounting: masters, ledgers, vouchers, cash book and invoices.",
    "tags": [
      "Unity 6, C#",
      "Firebase Authentication and Firestore",
      "Mailgun HTTP API"
    ],
    "repo": "https://github.com/PlatypusBoxOrganization/SimpleAcc_Soft",
    "private": true,
    "image": "/project-art/SimpleAcc_Soft.webp"
  },
  {
    "id": "SlotMachine",
    "title": "Slot Machine",
    "category": "Games",
    "tagline": "Slot machine with spinning reels",
    "description": "A Unity slot machine with reel spinning, currency and audio.",
    "tags": [
      "Unity, C#"
    ],
    "repo": "https://github.com/PlatypusBoxOrganization/SlotMachine",
    "private": true,
    "image": "/project-art/SlotMachine.webp"
  },
  {
    "id": "Slot_Game",
    "title": "Slot Game",
    "category": "IoT & Hardware",
    "tagline": "Kinect body-tracking slot/arcade game",
    "description": "A Unity project on the Kinect samples, using body tracking to catch eggs and balls and to control avatars.",
    "tags": [
      "Unity, C#, Kinect SDK samples"
    ],
    "repo": "https://github.com/gdevabhi/Slot_Game",
    "private": true,
    "image": "/project-art/Slot_Game.webp"
  },
  {
    "id": "SolarVRBattery_Sim",
    "title": "Solar VR Battery Sim",
    "category": "AR / VR",
    "tagline": "VR simulator for installing a home solar battery",
    "description": "A Unity XR project that walks a user through a solar battery wall installation in VR, with hand tracking and a spatial keyboard.",
    "tags": [
      "Unity, C#, XR Interaction Toolkit"
    ],
    "repo": "https://github.com/PlatypusBoxOrganization/SolarVRBattery_Sim",
    "private": true,
    "image": "/project-art/SolarVRBattery_Sim.webp"
  },
  {
    "id": "Solar_View_New",
    "title": "Solar View New",
    "category": "Simulation & Tools",
    "tagline": "Interactive solar installation viewer with quick-view camera controls",
    "description": "A Unity URP project (branch Ruchika_URP) for viewing a solar setup in 2D/3D with touch-style camera navigation and drawing/annotation.",
    "tags": [
      "Unity (URP), C#",
      "Lean Touch input, custom drawing scripts"
    ],
    "repo": "https://github.com/ruchibhaniwal/Solar_View_New",
    "private": true,
    "image": "/project-art/Solar_View_New.webp"
  },
  {
    "id": "SpinTheWheelUnity",
    "title": "Spin The Wheel Unity",
    "category": "AI & Vision",
    "tagline": "Spin-the-wheel game with MediaPipe tracking assets",
    "description": "A Unity spin-the-wheel project that bundles the MediaPipe Unity plugin and TextMesh Pro examples.",
    "tags": [
      "Unity, C#, MediaPipe Unity plugin"
    ],
    "repo": "https://github.com/PlatypusBoxOrganization/SpinTheWheelUnity",
    "private": true,
    "image": "/project-art/SpinTheWheelUnity.webp"
  },
  {
    "id": "SquashMate",
    "title": "Squash Mate",
    "category": "IoT & Hardware",
    "tagline": "Squash practice machine controller over Bluetooth",
    "description": "A Unity app (branch develop) that connects to a squash ball machine over Bluetooth LE and lets users manage free shots and profiles.",
    "tags": [
      "Unity, C#, BLE plugin"
    ],
    "repo": "https://github.com/PlatypusBoxOrganization/SquashMate",
    "private": true,
    "image": "/project-art/SquashMate.webp"
  },
  {
    "id": "Stickman_SJ",
    "title": "Stickman SJ",
    "category": "Games",
    "tagline": "2D stickman platformer prototype",
    "description": "A small Unity 2D platformer with a player controller and one level, built with the Easy Mobile toolkit.",
    "tags": [
      "Unity, C#, Easy Mobile"
    ],
    "repo": "https://github.com/PlatypusBoxOrganization/Stickman_SJ",
    "private": true,
    "image": "/project-art/Stickman_SJ.webp"
  },
  {
    "id": "SuzukiOffroadingExp",
    "title": "Suzuki Offroading Exp",
    "category": "AR / VR",
    "tagline": "Suzuki off-roading VR experience",
    "description": "A Unity VR project for an off-roading experience on the Meta Interaction SDK base.",
    "tags": [
      "Unity, C#, Meta XR SDK"
    ],
    "repo": "https://github.com/PlatypusBox/SuzukiOffroadingExp",
    "private": true,
    "image": "/project-art/SuzukiOffroadingExp.webp"
  },
  {
    "id": "Temple-Trashers",
    "title": "Temple Trashers",
    "category": "Games",
    "tagline": "Hex-grid tower defence: Temple Trashers",
    "description": "The Temple Trashers tower defence project with a hex grid, endless mode and a gallery.",
    "tags": [
      "Unity, C#, LeanTween"
    ],
    "repo": "https://github.com/PlatypusBoxOrganization/Temple-Trashers",
    "private": true,
    "image": "/project-art/Temple-Trashers.webp"
  },
  {
    "id": "TennisGame",
    "title": "Tennis Game",
    "category": "AR / VR",
    "tagline": "Tennis game with mixed-reality environment testing",
    "description": "A Unity project (branch Environment-Testing) exploring a 3D skybox, split screen and tunnel-distortion render effects for a tennis game.",
    "tags": [
      "Unity (URP), C#"
    ],
    "repo": "https://github.com/PlatypusBoxOrganization/TennisGame",
    "private": true,
    "image": "/project-art/TennisGame.webp"
  },
  {
    "id": "ThyroAIDProject",
    "title": "Thyro AID Project",
    "category": "AI & Vision",
    "tagline": "Thyroid diagnosis desktop front end",
    "description": "A Unity desktop app (branch Patient-details) for entering patient details and requesting thyroid diagnostics from a server.",
    "tags": [
      "Unity, C#",
      "Diagnostic backend (see thyroaid repos)"
    ],
    "repo": "https://github.com/PlatypusBox/ThyroAIDProject",
    "private": true,
    "image": "/project-art/ThyroAIDProject.webp"
  },
  {
    "id": "Tito",
    "title": "Tito",
    "category": "Games",
    "tagline": "Tito multiplayer mobile game (develop2)",
    "description": "A Unity mobile game (branch develop2) using Photon demos, particle effects and Google Mobile Ads.",
    "tags": [
      "Unity, C#, Photon, Google Mobile Ads"
    ],
    "repo": "https://github.com/PlatypusBox/Tito",
    "private": true,
    "image": "/project-art/Tito.webp"
  },
  {
    "id": "Top-Down-Shooter-Game",
    "title": "Top Down Shooter Game",
    "category": "Games",
    "tagline": "Top-down shooter with bosses and power-ups",
    "description": "A Unity 2D top-down shooter with procedurally generated rooms, enemies, bosses and power-ups.",
    "tags": [
      "Unity, C#"
    ],
    "repo": "https://github.com/PlatypusBoxOrganization/Top-Down-Shooter-Game",
    "private": true,
    "image": "/project-art/Top-Down-Shooter-Game.webp"
  },
  {
    "id": "UnityImageAIDrawingAsset",
    "title": "Unity Image AI Drawing Asset",
    "category": "Games",
    "tagline": "Kids drawing canvas with sticker, colour and clean-up mini-game",
    "description": "A Unity drawing asset with a paintable canvas, colour picker and stickers, plus a dish scrubbing mini-game.",
    "tags": [
      "Unity, C#"
    ],
    "repo": "https://github.com/PlatypusBoxOrganization/UnityImageAIDrawingAsset",
    "private": true,
    "image": "/project-art/UnityImageAIDrawingAsset.webp"
  },
  {
    "id": "UnityRoyale-Public",
    "title": "Unity Royale Public",
    "category": "Games",
    "tagline": "Unity Royale: Clash Royale style demo",
    "description": "The Unity Royale sample: a lane-battle card game with NavMesh units and VFX.",
    "tags": [
      "Unity, C#, NavMesh, DOTween"
    ],
    "repo": "https://github.com/PlatypusBoxOrganization/UnityRoyale-Public",
    "private": true,
    "image": "/project-art/UnityRoyale-Public.webp"
  },
  {
    "id": "UnityTetris",
    "title": "Unity Tetris",
    "category": "Games",
    "tagline": "Classic Tetris with settings, pause menu and control modes",
    "description": "A Unity Tetris clone with a playfield, tetrimino spawner, pooling and a settings window.",
    "tags": [
      "Unity, C#, TextMesh Pro"
    ],
    "repo": "https://github.com/PlatypusBoxOrganization/UnityTetris",
    "private": true,
    "image": "/project-art/UnityTetris.webp"
  },
  {
    "id": "VR-shopping-mall",
    "title": "VR Shopping Mall",
    "category": "AR / VR",
    "tagline": "VR shopping mall for an assistant and a customer",
    "description": "The first version of the VR mall app, designed so an assistant and a customer can meet in VR (Convai AI demo included).",
    "tags": [
      "Unity, C#, Convai"
    ],
    "repo": "https://github.com/PlatypusBoxOrganization/VR-shopping-mall",
    "private": true,
    "image": "/project-art/VR-shopping-mall.webp"
  },
  {
    "id": "VR-shopping-mall_internal",
    "title": "VR Shopping Mall (Internal)",
    "category": "AR / VR",
    "tagline": "Walk-through VR shopping mall with an AI shop assistant",
    "description": "A Unity VR project simulating a shopping mall, with a Convai conversational AI demo scene for talking to virtual characters.",
    "tags": [
      "Unity, C#, Convai SDK, Post-Processing Stack"
    ],
    "repo": "https://github.com/PlatypusBoxOrganization/VR-shopping-mall_internal",
    "private": true,
    "image": "/project-art/VR-shopping-mall_internal.webp"
  },
  {
    "id": "VRCE-2020",
    "title": "VRCE 2020",
    "category": "Games",
    "tagline": "Virtual Car Racing Engineer: fuel, lap and qualifying calculators",
    "description": "A Unity tool acting as a virtual race engineer, with calculators and lap logging for sim racing.",
    "tags": [
      "Unity, C#, TextMesh Pro"
    ],
    "repo": "https://github.com/PlatypusBoxOrganization/VRCE-2020",
    "private": true,
    "image": "/project-art/VRCE-2020.webp"
  },
  {
    "id": "VRPlayerCustomControl_Int",
    "title": "VR Player Custom Control",
    "category": "IoT & Hardware",
    "tagline": "VR video player with UDP remote control",
    "description": "A small Unity VR video player whose viewing modes can be switched remotely over UDP.",
    "tags": [
      "Unity, C#, UDP sockets"
    ],
    "repo": "https://github.com/PlatypusBoxOrganization/VRPlayerCustomControl_Int",
    "private": true,
    "image": "/project-art/VRPlayerCustomControl_Int.webp"
  },
  {
    "id": "VRSolarView",
    "title": "VR Solar View",
    "category": "AR / VR",
    "tagline": "VR solar installation viewer (XRI 3.1.2 based)",
    "description": "A Unity VR project based on the XR Interaction Toolkit 3.1.2 examples, with a solar battery wall installation experience.",
    "tags": [
      "Unity, C#, XR Interaction Toolkit 3.1.2"
    ],
    "repo": "https://github.com/PlatypusBoxOrganization/VRSolarView",
    "private": true,
    "image": "/project-art/VRSolarView.webp"
  },
  {
    "id": "VR_VideoPlayer",
    "title": "VR Video Player",
    "category": "IoT & Hardware",
    "tagline": "VR video player with curved screen and file picker",
    "description": "A Unity Meta Quest video player (branch develop) with a curved screen, file browser for Android and UDP remote control.",
    "tags": [
      "Unity, C#, Meta Interaction SDK"
    ],
    "repo": "https://github.com/PlatypusBoxOrganization/VR_VideoPlayer",
    "private": true,
    "image": "/project-art/VR_VideoPlayer.webp"
  },
  {
    "id": "Waves_Application",
    "title": "Waves Application",
    "category": "Mobile & Web Apps",
    "tagline": "Waves mobile app: web view only build",
    "description": "A Unity mobile app (branch onlyWebView) that wraps the Waves web portal in a WebView.",
    "tags": [
      "Unity, C#, UniWebView"
    ],
    "repo": "https://github.com/PlatypusBoxOrganization/Waves_Application",
    "private": true,
    "image": "/project-art/Waves_Application.webp"
  },
  {
    "id": "WebViewTest",
    "title": "Web View Test",
    "category": "Mobile & Web Apps",
    "tagline": "UniWebView test app with background video and centred layout",
    "description": "A test project (branch centeraligned) for embedding a web page in a Unity mobile app with a video background.",
    "tags": [
      "Unity, C#, UniWebView"
    ],
    "repo": "https://github.com/PlatypusBoxOrganization/WebViewTest",
    "private": true,
    "image": "/project-art/WebViewTest.webp"
  },
  {
    "id": "Werewolf_2D_Multiplayer",
    "title": "Werewolf 2D Multiplayer",
    "category": "Games",
    "tagline": "Online 2D Werewolf social-deduction game with voice chat",
    "description": "A Unity multiplayer game (branch Fusion-Connection-Issue-) using Photon Fusion networking and Photon Voice with proximity voice chat.",
    "tags": [
      "Unity, C#, Photon Fusion, Photon Voice"
    ],
    "repo": "https://github.com/PlatypusBoxOrganization/Werewolf_2D_Multiplayer",
    "private": true,
    "image": "/project-art/Werewolf_2D_Multiplayer.webp"
  },
  {
    "id": "WorldWarGame",
    "title": "World War Game",
    "category": "Games",
    "tagline": "World War strategy game (earlier build)",
    "description": "Earlier build of the war strategy game with login, building, airport, barracks and artillery systems. README needs two Unity packages from Google Drive.",
    "tags": [
      "Unity, C#, REST API"
    ],
    "repo": "https://github.com/PlatypusBoxOrganization/WorldWarGame",
    "private": true,
    "image": "/project-art/WorldWarGame.webp"
  },
  {
    "id": "WorldWarGame_int",
    "title": "World War Game",
    "category": "Games",
    "tagline": "Strategy game with base building, defence and TikTok Live gifts",
    "description": "A Unity war strategy game where players build bases, airports, barracks and artillery, with TikTok Live viewer gifts triggering in-game actions.",
    "tags": [
      "Unity, C#",
      "TikTok Live connector, REST API"
    ],
    "repo": "https://github.com/PlatypusBoxOrganization/WorldWarGame_int",
    "private": true,
    "image": "/project-art/WorldWarGame_int.webp"
  },
  {
    "id": "WorldWar_Terrain",
    "title": "World War Terrain",
    "category": "Games",
    "tagline": "War terrain and drone camera scenes",
    "description": "A Unity environment project with military assets and a drone camera controller, used as terrain for the war game.",
    "tags": [
      "Unity (BRP), C#"
    ],
    "repo": "https://github.com/PlatypusBoxOrganization/WorldWar_Terrain",
    "private": true,
    "image": "/project-art/WorldWar_Terrain.webp"
  },
  {
    "id": "ZipZapZoom",
    "title": "Zip Zap Zoom",
    "category": "Games",
    "tagline": "Fast casual runner with collectibles and ads",
    "description": "A Unity mobile game with collectable food items, ads and editor tooling.",
    "tags": [
      "Unity, C#, Google Mobile Ads"
    ],
    "repo": "https://github.com/PlatypusBoxOrganization/ZipZapZoom",
    "private": true,
    "image": "/project-art/ZipZapZoom.webp"
  },
  {
    "id": "beatpad",
    "title": "beatpad",
    "category": "Games",
    "tagline": "Beat pad music app with video and audio capture",
    "description": "A Unity drum/beat pad that records its audio output and video through a capture plugin.",
    "tags": [
      "Unity, C#, capture plugin"
    ],
    "repo": "https://github.com/PlatypusBox/beatpad",
    "private": true,
    "image": "/project-art/beatpad.webp"
  },
  {
    "id": "dish-wash",
    "title": "Dish Wash (Green)",
    "category": "Games",
    "tagline": "Dish washing game (green branch)",
    "description": "An earlier copy of the dish washing mini game (branch green) with scrub mechanics.",
    "tags": [
      "Unity, C#, TextMesh Pro"
    ],
    "repo": "https://github.com/Lakhbirpawar4unity/dish-wash",
    "private": true,
    "image": "/project-art/dish-wash.webp"
  },
  {
    "id": "dish-wash-int",
    "title": "Dish Wash",
    "category": "Games",
    "tagline": "Dish washing game with scrub mechanics",
    "description": "A casual Unity game where the player scrubs dirty dishes clean.",
    "tags": [
      "Unity, C#, TextMesh Pro"
    ],
    "repo": "https://github.com/PlatypusBoxOrganization/dish-wash-int",
    "private": true,
    "image": "/project-art/dish-wash-int.webp"
  },
  {
    "id": "draglineCraneMiningSimulation",
    "title": "dragline Crane Mining Simulation",
    "category": "Simulation & Tools",
    "tagline": "Dragline crane mining simulation with rope physics",
    "description": "A Unity simulation of a mining dragline crane using Obi Rope for chains and cables.",
    "tags": [
      "Unity, C#, Obi Rope"
    ],
    "repo": "https://github.com/PlatypusBoxOrganization/draglineCraneMiningSimulation",
    "private": true,
    "image": "/project-art/draglineCraneMiningSimulation.webp"
  },
  {
    "id": "golf_simulator",
    "title": "Golf Simulator",
    "category": "Games",
    "tagline": "3D golf simulator with ball camera",
    "description": "A Unity golf game with ball physics, aerial and ball-follow cameras, and touch buttons.",
    "tags": [
      "Unity, C#"
    ],
    "repo": "https://github.com/PlatypusBoxOrganization/golf_simulator",
    "private": true,
    "image": "/project-art/golf_simulator.webp"
  },
  {
    "id": "ifeproject",
    "title": "IFE Project (Develop)",
    "category": "Business Apps",
    "tagline": "In-flight entertainment project (develop)",
    "description": "The develop branch of the in-flight entertainment app with Online Maps, flight routes and entertainment panels.",
    "tags": [
      "Unity, C#, Online Maps"
    ],
    "repo": "https://github.com/IFE-MSFS/ifeproject",
    "private": true,
    "image": "/project-art/ifeproject.webp"
  },
  {
    "id": "inflitration",
    "title": "inflitration",
    "category": "Games",
    "tagline": "First-person stealth infiltration prototype",
    "description": "A Unity stealth game where the player avoids cameras and fans, collects key cards and opens doors.",
    "tags": [
      "Unity, C#, Standard Assets"
    ],
    "repo": "https://github.com/PlatypusBoxOrganization/inflitration",
    "private": true,
    "image": "/project-art/inflitration.webp"
  },
  {
    "id": "meta-videoplayer",
    "title": "meta videoplayer",
    "category": "IoT & Hardware",
    "tagline": "Meta Quest video player (fork by machine0man)",
    "description": "A copy of the VR video player work: curved screen, file picker and UDP control on the Meta Interaction SDK.",
    "tags": [
      "Unity, C#, Meta XR SDK"
    ],
    "repo": "https://github.com/machine0man/meta-videoplayer",
    "private": true,
    "image": "/project-art/meta-videoplayer.webp"
  },
  {
    "id": "oddsViewerLiveApp",
    "title": "odds Viewer Live App",
    "category": "Business Apps",
    "tagline": "Live cricket match scores and bookmaker odds viewer",
    "description": "A Unity app (branch develop) that shows live fixtures, a scoreboard and odds data fetched from a backend API, with Google sign-in.",
    "tags": [
      "Unity, C#, Google Sign-In plugin",
      "REST backend (OddsViewerBackend)"
    ],
    "repo": "https://github.com/PlatypusBoxOrganization/oddsViewerLiveApp",
    "private": true,
    "image": "/project-art/oddsViewerLiveApp.webp"
  },
  {
    "id": "oddsViewerLiveScoringApplication",
    "title": "odds Viewer Live Scoring Application",
    "category": "Business Apps",
    "tagline": "Earlier version of the live scoring and odds viewer",
    "description": "Previous Unity build of the cricket live scores and odds viewer, with Google sign-in and fixture lists.",
    "tags": [
      "Unity, C#, Google Sign-In"
    ],
    "repo": "https://github.com/PlatypusBoxOrganization/oddsViewerLiveScoringApplication",
    "private": true,
    "image": "/project-art/oddsViewerLiveScoringApplication.webp"
  },
  {
    "id": "pigeonDelivery",
    "title": "pigeon Delivery",
    "category": "Games",
    "tagline": "Pigeon delivery multiplayer prototype",
    "description": "A Unity prototype with Photon chat and a main scene for a pigeon delivery game.",
    "tags": [
      "Unity, C#, Photon"
    ],
    "repo": "https://github.com/PlatypusBox/pigeonDelivery",
    "private": true,
    "image": "/project-art/pigeonDelivery.webp"
  },
  {
    "id": "startcraft-unity3d",
    "title": "startcraft unity3d",
    "category": "Games",
    "tagline": "StarCraft style RTS prototype with A* pathfinding",
    "description": "A Unity RTS prototype using the A* Pathfinding Project for unit movement.",
    "tags": [
      "Unity, C#, A* Pathfinding Project"
    ],
    "repo": "https://github.com/PlatypusBoxOrganization/startcraft-unity3d",
    "private": true,
    "image": "/project-art/startcraft-unity3d.webp"
  },
  {
    "id": "tower_defense_2d",
    "title": "Tower Defense 2D",
    "category": "Games",
    "tagline": "2D tower defence game",
    "description": "A small Unity tower defence game with enemy waves, buyable towers and speed controls.",
    "tags": [
      "Unity, C#"
    ],
    "repo": "https://github.com/PlatypusBoxOrganization/tower_defense_2d",
    "private": true,
    "image": "/project-art/tower_defense_2d.webp"
  },
  {
    "id": "weed",
    "title": "weed",
    "category": "Games",
    "tagline": "Multiplayer social/chat game prototype with localisation",
    "description": "A Unity project built on Photon (Chat, Realtime and PUN demos) with a localisation system, used as the base of a multiplayer app.",
    "tags": [
      "Unity, C#, Photon PUN / Photon Chat"
    ],
    "repo": "https://github.com/PlatypusBoxOrganization/weed",
    "private": true,
    "image": "/project-art/weed.webp"
  },
  {
    "id": "zomboid-survival",
    "title": "zomboid survival",
    "category": "Games",
    "tagline": "Zombie survival first-person prototype (menu and settings)",
    "description": "An earlier build of the zombie survival prototype, with main menu and settings scenes, on Standard Assets controllers.",
    "tags": [
      "Unity, C#, Standard Assets"
    ],
    "repo": "https://github.com/PlatypusBoxOrganization/zomboid-survival",
    "private": true,
    "image": "/project-art/zomboid-survival.webp"
  },
  {
    "id": "zomboid-survival-Unity",
    "title": "zomboid survival Unity",
    "category": "Games",
    "tagline": "Zombie survival first-person prototype",
    "description": "A Unity first-person survival project on the Standard Assets controllers, with an asylum environment and sandbox.",
    "tags": [
      "Unity, C#, Standard Assets"
    ],
    "repo": "https://github.com/PlatypusBoxOrganization/zomboid-survival-Unity",
    "private": true,
    "image": "/project-art/zomboid-survival-Unity.webp"
  }
];
